import { Skeleton as SK } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Skeleton = styled(SK)({
  '& .MuiSkeleton-root': {
    backgroundColor: 'rgba(0, 0, 0, 0.08) !important',
  },
});
